/**
 * QuickLinksBar
 */
import clsx from 'clsx';
import React from 'react';
import { Cell, Grid } from '..';
/** Main description for this component. */
var QuickLinksBar = function (_a) {
    var children = _a.children, className = _a.className, ariaLabel = _a["aria-label"];
    return (React.createElement("nav", { "aria-label": ariaLabel, "data-cid": "QuickLinksBar", className: clsx(className, 'relative bg-greyLighter py-3 overflow-hidden border-b border-greyLight quick-links-bar') },
        React.createElement(Grid, { padding: false, className: "pl-4 lg:pl-6" },
            React.createElement(Cell, { span: 12 },
                React.createElement("ul", { className: "text-p flex justify-end" }, children)))));
};
export default QuickLinksBar;
